import { createFileRoute, redirect } from '@tanstack/react-router'
import { getLoginAppOrigin } from '@/lib/login-app-url'
import { hasAccessToken } from '@/lib/token-storage'

/**
 * O login centralizado fica no pacote `login/` (Vite).
 * Qualquer acesso a "/" no app principal redireciona para o app de login.
 */
export const Route = createFileRoute('/(auth)/')({
  beforeLoad: () => {
    const origin = getLoginAppOrigin()
    if (!origin) {
      if (hasAccessToken()) {
        throw redirect({ to: '/workspace' })
      }
      throw redirect({ to: '/configuracao-login' })
    }
    const search = typeof window !== 'undefined' ? window.location.search : ''
    throw redirect({ href: `${origin}${search}` })
  },
})
